import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ProgramsMobileColumn = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span><strong>{ row.name }</strong></span>
			<br />
			<span>{ row.submissionStatus }</span>
		</div>
	);
};

ProgramsMobileColumn.propTypes = { row: PropTypes.object.isRequired };

export default memo( ProgramsMobileColumn );
